<template>
  <MediaControl
    v-if="avctl && shareType === 4"
    ref="control"
    :current-time.sync="currentTime"
    :duration="duration"
    slot="bottom"
    @ready="onReady"
    @end="onEnd"
    @change="onChange"
  />
</template>
<script>
// 控制条
import MediaControl from "@/components/media/control";
import { mapGetters } from "vuex";
import Role from "@/mixins/role";
import { resourceSeek, resourceEnd } from "@/api/liveRequest/resource";
import Bus from "@/components/doc/bus";
import {
  pushRoomMessageFunc,
  removeMessageFunc,
} from "@/utils/socketMessageDispose";
export default {
  name: "pseudoControl",
  components: {
    MediaControl,
  },
  mixins: [Role],
  data() {
    return {
      // 伪直播:当前播放进度
      currentTime: 0,
      duration: 0,
      stopEvent: undefined,
    };
  },
  computed: {
    ...mapGetters(["shareType"]),
  },
  created() {
    pushRoomMessageFunc(this.message_event);
  },
  mounted() {
    this.stopEvent = () => {
      this.$refs.control?.end();
      console.log("执行 stopEvent")
      this.$store.commit("SET_SHARE_TYPE", -1);
    };
    Bus.$on("pse:stop", this.stopEvent);
  },
  beforeDestroy() {
    removeMessageFunc(this.message_event);
    Bus.$off("pse:stop", this.stopEvent);
  },
  methods: {
    message_event({ cmd, requestData }) {
      switch (cmd) {
        case 7125:
          this.message_7125(requestData);
          break;
        case 7127:
          this.message_7127(requestData);
          break;
      }
    },
    message_7125(body) {
      switch (`${body.cmd}`) {
        case "7002":
          this.$store.commit("SET_SHARE_TYPE", 4);
          this.duration = body.totaltime / 1000;
          this.currentTime = body.playtime / 1000;
          break;
      }
    },
    message_7127(body) {
      console.log("control.....")
      switch (body.event) {
        case "assistant_webcast_stream_status":
          if (body.opType !== 3) {
            return;
          }
          console.log('return control.....')
          // stop
          if (body.streamStatus === 1) {
            Bus.$emit("pse:stop");
          }
          // play
          if (body.streamStatus === 0) {
            console.log(body.streamStatus, "streamStatus,.,,,")
            Bus.$emit("pse:play");
          }
          break;
      }
    },
    play() {
      this.$refs.control?.play();
    },
    onReady() {
      this.play();
    },
    // seek
    onChange() {
      this.startSeek(this.currentTime);
    },
    // 结束
    async onEnd() {
      const { code, msg } = await resourceEnd();
      if (code !== 200) {
        this.$message.error(msg);
        return;
      } else {
        Bus.$emit("pse:stop");
      }
    },
    // 发送seek请求
    async startSeek(seektime) {
      const { code, msg } = await resourceSeek(seektime * 1000);
      if (code !== 200) {
        this.$message.error(msg);
        return;
      }
    },
  },
};
</script>